import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Sparkles, Flame, Trophy, LogOut, LayoutDashboard, Shield, Target, CreditCard } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;

  return (
    <header className="sticky top-0 z-40 bg-[#FBF9F6]/85 backdrop-blur-md border-b border-black/5">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/hub" className="flex items-center gap-2" data-testid="nav-logo">
          <div className="w-9 h-9 rounded-2xl bg-[#E8A87C] flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="font-head font-extrabold text-lg tracking-tight">WAIT <span className="text-[#E8A87C]">Mental Health</span></span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-4">
          {user.role !== "admin" && !user.subscription_active && (
            <Link
              to="/subscribe"
              className="hidden sm:inline-flex items-center gap-1.5 bg-[#E8A87C] text-white text-sm font-semibold px-4 py-2 rounded-full hover:-translate-y-0.5 transition-transform"
              data-testid="nav-upgrade"
            >
              <Sparkles className="w-4 h-4" /> Upgrade $3/mo
            </Link>
          )}
          <div className="hidden sm:flex items-center gap-3 mr-2">
            <span className="flex items-center gap-1 text-sm font-semibold" data-testid="nav-points">
              <Trophy className="w-4 h-4" style={{ color: "#D4AF37" }} /> {user.points ?? 0}
            </span>
            <span className="flex items-center gap-1 text-sm font-semibold" data-testid="nav-streak">
              <Flame className="w-4 h-4" style={{ color: "#FF7B54" }} /> {user.streak ?? 0}
            </span>
          </div>
          <Link
            to="/plan"
            className="p-2 rounded-full hover:bg-black/5 transition-colors"
            data-testid="nav-plan"
            title="Weekly plan"
          >
            <Target className="w-5 h-5" />
          </Link>
          <Link
            to="/dashboard"
            className="p-2 rounded-full hover:bg-black/5 transition-colors"
            data-testid="nav-dashboard"
            title="Dashboard"
          >
            <LayoutDashboard className="w-5 h-5" />
          </Link>
          {user.role !== "admin" && (
            <Link
              to="/manage-subscription"
              className="p-2 rounded-full hover:bg-black/5 transition-colors"
              data-testid="nav-manage-subscription"
              title="Manage subscription"
            >
              <CreditCard className="w-5 h-5" />
            </Link>
          )}
          {user.role === "admin" && (
            <Link
              to="/admin"
              className="p-2 rounded-full hover:bg-black/5 transition-colors"
              data-testid="nav-admin"
              title="Admin"
            >
              <Shield className="w-5 h-5" />
            </Link>
          )}
          <button
            onClick={() => {
              logout();
              navigate("/login");
            }}
            className="p-2 rounded-full hover:bg-black/5 transition-colors"
            data-testid="nav-logout"
            title="Log out"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
